// src/chat.js

// Import necessary components from installed AWS SDK packages
// These imports will be resolved by Parcel from your node_modules folder
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

// Import Lex Runtime V2 client and commands
// Using RecognizeTextCommand based on previous build errors
import { LexRuntimeV2Client, RecognizeTextCommand, GetSessionCommand } from "@aws-sdk/client-lex-runtime-v2";


// Use jQuery as it's common in WordPress, wrap in document ready
// jQuery is assumed to be enqueued by WordPress and available globally ($)
jQuery(document).ready(function($) {

    // --- 1. Get DOM Elements and Localized Data ---
    const chatBubble = $("#lex-chat-bubble");
    const chatContainer = $("#lex-chat-container");
    const chatCloseButton = $("#lex-chat-close");
    const chatbox = $("#lex-chatbox");
    const chatInput = $("#lex-chat-input");
    const sendButton = $("#lex-chat-send");

    // Get configuration data passed from PHP via wp_localize_script
    const config = myLexV2Chat;

    // --- Implement Persistent Guest User ID using localStorage ---
    let currentUserId = config.userId;
    if (currentUserId.startsWith("wp_guest_")) {
        const localStorageKey = "lex_chat_guest_user_id";
        const storedUserId = localStorage.getItem(localStorageKey);
        if (storedUserId) { currentUserId = storedUserId; console.log("Using stored Lex guest user ID:", currentUserId); }
        else { localStorage.setItem(localStorageKey, currentUserId); console.log("Generated and stored new Lex guest user ID:", currentUserId); }
    } else { console.log("Using logged-in Lex user ID:", currentUserId); }


    // --- 2. AWS SDK Client Initialization (v3 Modular Syntax) ---

    const cognitoClient = new CognitoIdentityClient({ region: config.region });

    const cognitoProvider = fromCognitoIdentityPool({
        client: cognitoClient,
        identityPoolId: config.identityPoolId,
    });

    const lexClient = new LexRuntimeV2Client({
        region: config.region,
        credentials: cognitoProvider,
    });


    // --- 3. UI Functions ---

    // Function to display a message in the chatbox (user or bot)
    function displayMessage(sender, messageText) {
        const messageClass = sender === "You" ? "user-message" : "bot-message";
        const messageElement = $("<p>").addClass(messageClass);

        // Use .text() to prevent XSS issues if messageText contains HTML
        messageElement.text(messageText);

        chatbox.append(messageElement);

        // Auto-scroll to the bottom to show the latest message
        chatbox.scrollTop(chatbox[0].scrollHeight);
    }

    // Function to toggle the visibility of the main chat window
    function toggleChatWindow(show) {
        if (show === true) {
            chatContainer.addClass("open"); // Add the 'open' class to make it visible via CSS
            // Optional: Focus on the input field when opening for usability
            setTimeout(() => chatInput.focus(), 300); // Add a slight delay to allow CSS transition
        } else if (show === false) {
            chatContainer.removeClass("open"); // Remove the 'open' class to hide it
            // Optional: Remove focus from the input when closing
            chatInput.blur();
        } else {
            // Toggle the 'open' class if 'show' is not explicitly true or false
            chatContainer.toggleClass("open");
            if (chatContainer.hasClass("open")) {
                 setTimeout(() => chatInput.focus(), 300);
            } else {
                 chatInput.blur();
            }
        }
    }

    // --- 4. Lex Communication Function (v3 Modular Syntax) ---

    // Async function to send message using RecognizeTextCommand with Both V1 and V2 parameters
    async function sendMessageToLexV2(message) {
        // Disable input and send button while waiting for a response
        chatInput.prop("disabled", true);
        sendButton.prop("disabled", true);

        // Create a new RecognizeTextCommand instance including both V1 and V2 parameters
        const command = new RecognizeTextCommand({
            botName: config.botName, // Use V1 Bot Name from PHP
            botAlias: config.botAlias, // Use V1 Bot Alias from PHP
            botId: config.botId, // Include V2 Bot ID from PHP
            botAliasId: config.botAliasId, // Include V2 Bot Alias ID from PHP
            localeId: config.localeId,
            sessionId: currentUserId,
            text: message,
        });

        try {
            const data = await lexClient.send(command);
            console.log("Lex Response:", data);

            // Process the response messages from Lex
            // The response structure might differ slightly between PostText and RecognizeText
            if (data.messages && data.messages.length > 0) {
                data.messages.forEach((msg) => {
                    if (msg.content) {
                        displayMessage("Bot", msg.content);
                    }
                });
            } else {
                console.log("Lex response contained no messages.");
            }

        } catch (error) {
            console.error("Error sending message to Lex:", error);
            displayMessage(
                "Bot",
                "Sorry, there was an error communicating with the chatbot. (" +
                (error.message || error) +
                ")"
            );
        } finally {
            // Re-enable input field and send button after the API call completes (success or failure)
            chatInput.prop("disabled", false);
            sendButton.prop("disabled", false);
            chatInput.focus();
        }
    }

    // --- 5. Handle User Input ---

    // Function triggered when the user attempts to send a message from the UI
    function handleUserMessageInput() {
        const message = chatInput.val().trim(); // Get the input value and remove leading/trailing whitespace

        // Prevent sending empty messages or sending while input is disabled
        if (message === "" || chatInput.prop("disabled")) {
            console.log("handleUserMessageInput returning early. Message empty?", message === "", "Input disabled?", chatInput.prop("disabled"));
            return;
        }

        // Display the user's message in the chatbox immediately
        displayMessage("You", message);

        // Clear the input field
        chatInput.val("");

        // Call the async function to send the message to Lex
        sendMessageToLexV2(message);
    }

    // --- 6. Event Listeners ---

    // Attach click event listener to the chat bubble to open the chat window
    chatBubble.on("click", function () {
        toggleChatWindow(true); // Explicitly show the window
        console.log("Chat bubble clicked!"); // Log for debugging
    });

    // Attach click event listener to the close button to close the chat window
    chatCloseButton.on("click", function () {
        toggleChatWindow(false); // Explicitly hide the window
    });

    sendButton.on("click", handleUserMessageInput);

    chatInput.on("keypress", function (event) {
        if (event.which === 13) { // Check if the pressed key is Enter (key code 13)
            event.preventDefault(); // Prevent default form submission behavior
            handleUserMessageInput(); // Trigger the message handling function
        }
    });

    // --- Optional: Initial Message or Action on Load/Open ---
    // You could add logic here to send an initial message to the bot when the page loads
    // or when the chat window is first opened.
});
